import { createContext } from 'react'

import type { MediaQueryState } from './MediaGuard'

export interface MediaContextType {
  matches: MediaQueryState
}

const MediaContext = createContext<MediaContextType | undefined>(undefined)

export default MediaContext